export default __webpack_public_path__ + "static/media/video1.4437004e.svg";